// extracted by mini-css-extract-plugin
export default {"copyrightInfo":"Footer_copyrightInfo__ShzDA","copyrightInfo--client":"Footer_copyrightInfo--client__8jQ5G","copyrightInfo--guest":"Footer_copyrightInfo--guest__IB6gZ"};